// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard_title {
    font-size: 17px;
    color: #0877BC;
    text-align: left;
}

.wizard_time {
    font-size: 11px;
    color: #0877BC;
    text-align: right;

}

.Wizard_CB {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;

}

.wizard_setup {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin: 10px;
    padding-bottom: 7px;
    border-bottom: 1px solid #c1c1c1;
}

.wizard_cb_add {
    display: flex;
    gap: 5px;
}

.wizard_cb_num {
    width: 15px;

}

.wizard_cb_action {
    width: 13px;

    cursor: pointer;
    background-color: #0877BC;
    width: 20px;
    height: 20px;
    border-radius: 50px;
    color: #fff;
}

.wizard_edittime>input[number] {}

.Wizard_cb_info {
    border: 1px solid #0877BC;
    padding: 1px 5px;
    font-size: 10px !important;
    margin: 2px;
    border-radius: 10px;
    cursor: pointer;

}


.wizard_card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #0877BC;
    box-shadow: 1px 1px 10px 0px #053e6130;
    padding: 7px;
    border-radius: 10px;
    margin: 5px 0;


}

.wizard_info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;

    img {
        width: 55px;
        border: 3px solid #0877BC;
        padding: 7px 5px;
        border-radius: 10px;
    }

    p {
        font-weight: 600;
        font-size: 13px;
    }
}

.Wizard_editdiv {
    display: flex;
    gap: 3px;
}

.wizard_edittime {
    border: 1px solid #0877BC;
    border-radius: 6px;
    padding: 7px 10px;

    input {
        font-size: 20px;
        font-weight: 600;
        width: 23px;
        color: #0877BC;
        background-color: transparent;
        border: none;
        outline: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    p {
        font-size: 9px;
    }
}

.CB_page {
    background-color: #fff;
    position: absolute;
    top: 0%;
    left: 0;
    width: calc(100% - 20px);
    border-radius: 10px;
    margin: 20px;
    padding: 10px;


}

.CB_alllist {
    list-style-type: none;
}

.CB_count {
    display: flex;
    align-items: center;
    gap: 2px;

    >p {
        background-color: #0877BC;
        color: #fff;
        border-radius: 50%;
        width: 20px;
        height: 15px;
        font-size: 15px;
    }
}

.guests_totalcount {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 15px 5px;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;
}

.guests_totalcount>p {
    font-weight: 700;
    font-size: 14px;
    color: #02111b;
}

.guest_count {
    display: flex;
    align-items: center;
    gap: 15px
}`, "",{"version":3,"sources":["webpack://./src/pages/Exerciseadd/Wizardsession.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;;IAEX,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;;AAEA,gCAAgC;;AAEhC;IACI,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;IACnB,eAAe;;AAEnB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,sCAAsC;IACtC,YAAY;IACZ,mBAAmB;IACnB,aAAa;;;AAGjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;;IAEf;QACI,WAAW;QACX,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;;IAEjB;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd,6BAA6B;QAC7B,YAAY;QACZ,aAAa;IACjB;;IAEA;;QAEI,wBAAwB;QACxB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,OAAO;IACP,OAAO;IACP,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;IACZ,aAAa;;;AAGjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER;QACI,yBAAyB;QACzB,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ","sourcesContent":[".wizard_title {\n    font-size: 17px;\n    color: #0877BC;\n    text-align: left;\n}\n\n.wizard_time {\n    font-size: 11px;\n    color: #0877BC;\n    text-align: right;\n\n}\n\n.Wizard_CB {\n    display: flex;\n    gap: 5px;\n    flex-wrap: wrap;\n\n}\n\n.wizard_setup {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    margin: 10px;\n    padding-bottom: 7px;\n    border-bottom: 1px solid #c1c1c1;\n}\n\n.wizard_cb_add {\n    display: flex;\n    gap: 5px;\n}\n\n.wizard_cb_num {\n    width: 15px;\n\n}\n\n.wizard_cb_action {\n    width: 13px;\n\n    cursor: pointer;\n    background-color: #0877BC;\n    width: 20px;\n    height: 20px;\n    border-radius: 50px;\n    color: #fff;\n}\n\n.wizard_edittime>input[number] {}\n\n.Wizard_cb_info {\n    border: 1px solid #0877BC;\n    padding: 1px 5px;\n    font-size: 10px !important;\n    margin: 2px;\n    border-radius: 10px;\n    cursor: pointer;\n\n}\n\n\n.wizard_card {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #0877BC;\n    box-shadow: 1px 1px 10px 0px #053e6130;\n    padding: 7px;\n    border-radius: 10px;\n    margin: 5px 0;\n\n\n}\n\n.wizard_info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 15px;\n\n    img {\n        width: 55px;\n        border: 3px solid #0877BC;\n        padding: 7px 5px;\n        border-radius: 10px;\n    }\n\n    p {\n        font-weight: 600;\n        font-size: 13px;\n    }\n}\n\n.Wizard_editdiv {\n    display: flex;\n    gap: 3px;\n}\n\n.wizard_edittime {\n    border: 1px solid #0877BC;\n    border-radius: 6px;\n    padding: 7px 10px;\n\n    input {\n        font-size: 20px;\n        font-weight: 600;\n        width: 23px;\n        color: #0877BC;\n        background-color: transparent;\n        border: none;\n        outline: none;\n    }\n\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    p {\n        font-size: 9px;\n    }\n}\n\n.CB_page {\n    background-color: #fff;\n    position: absolute;\n    top: 0%;\n    left: 0;\n    width: calc(100% - 20px);\n    border-radius: 10px;\n    margin: 20px;\n    padding: 10px;\n\n\n}\n\n.CB_alllist {\n    list-style-type: none;\n}\n\n.CB_count {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n\n    >p {\n        background-color: #0877BC;\n        color: #fff;\n        border-radius: 50%;\n        width: 20px;\n        height: 15px;\n        font-size: 15px;\n    }\n}\n\n.guests_totalcount {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 15px 5px;\n    padding: 10px 0;\n    border-bottom: 1px solid #ccc;\n}\n\n.guests_totalcount>p {\n    font-weight: 700;\n    font-size: 14px;\n    color: #02111b;\n}\n\n.guest_count {\n    display: flex;\n    align-items: center;\n    gap: 15px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
